import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteConfigComponentProps } from 'react-router-config';
import { Box } from '@cp/ds/src/components/box';
import Header from 'src/widgets/header';
import { SiteFaq } from './components/siteFaq';

const FaqPage: React.FC<RouteConfigComponentProps> = () => {
  return (
    <Box component="section">
      <Helmet>
        <title>Ответы на часто задаваемые вопросы - YouHelp</title>
        <meta content="Ответы на самые частые вопросы нанимателей и специалистов." name="description" />
      </Helmet>

      <Header />

      <SiteFaq />
    </Box>
  );
};

export default FaqPage;
